import RichText from '@/features/shared/RichText';
import { Theme } from '@/utils/constants';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';
import { IAccordionGroup } from './AccordionGroup.interface';
import { Accordion, AccordionDetails, AccordionSummary, useStyles } from './AccordionGroup.styles';

const AccordionGroup = (props: IAccordionGroup) => {
  const styles = useStyles({});

  return (
    <div className={styles.root}>
      <RichText theme={Theme.dark} className={styles.groupTitle} content={props.groupSummary} />
      <div>
        {props?.items?.map((item, index) => (
          <Accordion key={index.toString()} defaultExpanded={!item.isCollapsed}>
            <AccordionSummary className="accordion-summary" expandIcon={<ExpandMoreIcon />}>
              <RichText theme={Theme.dark} className={styles.title} content={item.title} />
            </AccordionSummary>
            <AccordionDetails>
              <RichText theme={Theme.dark} className={styles.content} content={item.content} />
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </div>
  );
};

export default React.memo(AccordionGroup);
